module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-08-b0cbbc1c7cbbca9e1766a595c7dd2be5.jpg";